import { type SkeletorResponse } from '@store/skeletor/types';

const NEW = 'NEW';
const IN_PROCESS = 'IN_PROCESS';
const SENT = 'SENT';
const ABANDONED = 'ABANDONED';
const DRAFT = 'DRAFT';
const IN_VERIFICATION = 'IN_VERIFICATION';
const IN_TREASURY = 'IN_TREASURY';
const IN_DEPOSIT = 'IN_DEPOSIT';
const CLOSED = 'CLOSED';
const REJECTED = 'REJECTED';

type QuoteRequestStatus =
  | typeof NEW
  | typeof IN_PROCESS
  | typeof SENT
  | typeof ABANDONED
  | typeof DRAFT
  | typeof IN_VERIFICATION
  | typeof IN_TREASURY
  | typeof IN_DEPOSIT
  | typeof CLOSED
  | typeof REJECTED;

type QuoteRequestState = {
  id: string;
  name: QuoteRequestStatus;
  label?: string;
  description: string;
};

type GetApiQuoteRequestStates = SkeletorResponse<QuoteRequestState[]>;

export {
  ABANDONED,
  CLOSED,
  DRAFT,
  IN_DEPOSIT,
  IN_PROCESS,
  IN_TREASURY,
  IN_VERIFICATION,
  NEW,
  REJECTED,
  SENT,
};

export type { GetApiQuoteRequestStates, QuoteRequestState, QuoteRequestStatus };
